var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72302 14.96V20.9466C4.72302 26.9333 7.12302 29.3333 13.1097 29.3333H20.2964C26.283 29.3333 28.683 26.9333 28.683 20.9466V14.96",
    stroke: "#91268F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 16C19.1497 16 20.9497 14.0134 20.7097 11.5734L19.8297 2.66669H13.603L12.7097 11.5734C12.4697 14.0134 14.2697 16 16.7097 16Z",
    stroke: "#91268F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1232 16C27.8165 16 29.7898 13.8134 29.5232 11.1334L29.1498 7.46669C28.6698 4.00002 27.3365 2.66669 23.8432 2.66669H19.7765L20.7098 12.0134C20.9365 14.2134 22.9232 16 25.1232 16Z",
    stroke: "#91268F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22956 16C10.4296 16 12.4162 14.2134 12.6296 12.0134L12.9229 9.06669L13.5629 2.66669H9.49623C6.00289 2.66669 4.66956 4.00002 4.18956 7.46669L3.82956 11.1334C3.56289 13.8134 5.53623 16 8.22956 16Z",
    stroke: "#91268F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 22.6667C14.483 22.6667 13.3763 23.7734 13.3763 26V29.3334H20.043V26C20.043 23.7734 18.9363 22.6667 16.7097 22.6667Z",
    stroke: "#91268F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShop);
export default __webpack_public_path__ + "static/media/icon-Shop.a7b8aa053ee25188d24ab4f6576bbc16.svg";
export { ForwardRef as ReactComponent };